import { Amplify } from "aws-amplify";
import {
  cognitoCredentialsProvider,
  cognitoUserPoolsTokenProvider,
} from "aws-amplify/auth/cognito";
import { defaultStorage, parseAmplifyConfig } from "aws-amplify/utils";

import { getAmplifyOutputs } from "../amplify-backend/client";

import { _DO_NOT_USE_OUTSIDE_AMPLIFY_tokenProvider } from "./token-provider";

export async function configure({
  useIdentityPoolId,
}: { useIdentityPoolId?: boolean } = {}): Promise<void> {
  const amplifyOutputs = await getAmplifyOutputs();
  const parsedAmplifyConfig = parseAmplifyConfig(amplifyOutputs ?? {});
  if (parsedAmplifyConfig.Auth) {
    // Why can't we read top or window here? https://mobsuccess.slack.com/archives/C085N4WRW49/p1748433302303189?thread_ts=1748428868.072169&cid=C085N4WRW49
    const _msAuth = new Function("return window._msAuth")();
    if (_msAuth?.userPool?.userPoolsId) {
      parsedAmplifyConfig.Auth.Cognito.userPoolId =
        _msAuth.userPool.userPoolsId;
    }
    if (_msAuth?.userPool?.userPoolsWebClientId) {
      parsedAmplifyConfig.Auth.Cognito.userPoolClientId =
        _msAuth.userPool.userPoolsWebClientId;
    }
    if (_msAuth?.userPool?.identityPoolId) {
      parsedAmplifyConfig.Auth.Cognito.identityPoolId =
        _msAuth.userPool.identityPoolId;
    }

    if (!useIdentityPoolId) {
      // Identity pool is for AWS services, we don't always need it in the client
      // This avoids 2 blocking cognito calls (400ms)
      parsedAmplifyConfig.Auth.Cognito.identityPoolId = "";
    }
  }
  // Passing a custom `tokenProvider` to `Amplify.configure` makes the
  // runtime skip the default initialization of the cognito singleton
  // (see aws-amplify/initSingleton.ts: `if (libraryOptions?.Auth) return`).
  // Our token provider delegates to `cognitoUserPoolsTokenProvider` for the
  // password flow, so we must initialize it ourselves first.
  if (parsedAmplifyConfig.Auth) {
    cognitoUserPoolsTokenProvider.setAuthConfig(parsedAmplifyConfig.Auth);
    cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage);
  }
  // Providing `libraryOptions.Auth` makes Amplify skip its default Auth
  // providers entirely (see aws-amplify/initSingleton.ts), so the stock
  // credentials provider must be passed back explicitly — without it,
  // `fetchAuthSession().credentials` is always undefined and every direct
  // S3 call (e.g. `uploadData`) fails with `NoCredentials`.
  Amplify.configure(parsedAmplifyConfig, {
    Auth: {
      tokenProvider: _DO_NOT_USE_OUTSIDE_AMPLIFY_tokenProvider,
      credentialsProvider: cognitoCredentialsProvider,
    },
  });
}
